import React from 'react'
import ScrollBar from "../../../components/ScrollBar";
import Component from "../../../components/Component";
import ReactHtmlParser, {convertNodeToElement} from 'react-html-parser';

class WrippleEffectPanel extends Component {

    constructor(props) {
        super(props);

        this.state = {
            feedItems: [],
            currentFeedIndex: 0
        }
    }

    componentDidMount() {
        let feedItems = TB.sortBy(
            laravel.talent_dashboard_feed_items, 'display_index'
        );
        let feedInterval = setInterval(async () => {
            let feedIndex = this.state.currentFeedIndex + 1;
            if (feedIndex >= this.state.feedItems.length) {
                feedIndex = 0;
            }
            return this.setState({currentFeedIndex: feedIndex})
        }, 4000);

        this.setState({
            feedItems, feedInterval
        });

    }
    async setFeed(index) {
        if (this.state.feedInterval) {
            await clearInterval(this.state.feedInterval);
        }

        this.setState({currentFeedIndex: index, feedInterval: undefined})
    }

    render() {

        let {
            feedItems,
            currentFeedIndex,
        } = this.state;

        if (!feedItems?.length) {
            return null;
        }

        const transform = (node, index) => {
            if (node.name === 'div') {
                node.name = 'p';
                return convertNodeToElement(node,index, transform)
            }
            if (node.name === 'a') {
                node.attribs.target = '_blank';
                return convertNodeToElement(node,index, transform)
            }
            return undefined;
        }
        return (
            <div className="talent-dashboard-panel talent-dashboard-feed">
                <div className="talent-panel-content-container">
                    <div className="position-relative">

                        <ScrollBar
                            infinite={true}
                            target="default-scroll-container"
                            currentIndex={currentFeedIndex}
                            duration={1200}
                            onScroll={index => this.setFeed(index)}
                            showPagination={false}>


                            {feedItems?.length > 0 ? TB.map(feedItems, (feedItem, i) => (
                                <div key={`feed-item-${i}`} id={'default-scroll-container-' + i}
                                     className="default-scroll-panel">
                                    <div>
                                        {ReactHtmlParser(feedItem.body,{transform})}
                                    </div>
                                </div>
                            )) : (
                                <div key="feed-item-0" id={'default-scroll-container-0'}
                                     className="default-scroll-panel">
                                    <p>Check back here for news and updates.</p>
                                </div>
                            )}

                        </ScrollBar>

                        {/*{feedItems?.length > 0 && (*/}
                        {/*    <div className="feed-indicators">*/}
                        {/*        {feedItems.map((item, index) => (*/}
                        {/*            <span key={index} onClick={() => this.setFeed(index)}*/}
                        {/*                  className={TB.mapClass({*/}
                        {/*                      ['active no-click']: currentFeedIndex === index,*/}
                        {/*                      clickable: currentFeedIndex !== index*/}
                        {/*                  })}/>*/}
                        {/*        ))}*/}
                        {/*    </div>*/}
                        {/*)}*/}

                    </div>
                </div>
            </div>
        )
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        if (this.state.feedInterval) {
            clearInterval(this.state.feedInterval);
        }
    }
}

export default WrippleEffectPanel;
